import React from 'react';
import FormField from './FormField';

/**
 * Vertical radio option list — same pattern as batch carry-forward policy.
 */
export default function RadioGroup({
    label,
    name,
    value,
    onChange,
    options = [],
    required = false,
    className = '',
    disabled = false,
    note,
}) {
    return (
        <FormField label={label} required={required} className={className} note={note}>
            <div className={`space-y-2 ${disabled ? 'opacity-50' : ''}`}>
                {options.map((opt) => {
                    const optValue = typeof opt === 'string' ? opt : opt.value;
                    const optLabel = typeof opt === 'string' ? opt : opt.label;
                    const optDesc = typeof opt === 'object' ? opt.description || opt.desc : null;
                    const inputId = `${name}-${optValue}`;

                    return (
                        <label
                            key={optValue}
                            htmlFor={inputId}
                            className={`flex items-start gap-3 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        >
                            <input
                                type="radio"
                                id={inputId}
                                name={name}
                                value={optValue}
                                checked={value === optValue}
                                onChange={onChange}
                                required={required}
                                disabled={disabled}
                                className="mt-1 h-4 w-4 border-slate-300 text-primary-600 focus:ring-primary-500"
                            />
                            <span>
                                <span className="text-sm font-medium text-slate-800">{optLabel}</span>
                                {optDesc ? <span className="block field-note !mt-0.5">{optDesc}</span> : null}
                            </span>
                        </label>
                    );
                })}
            </div>
        </FormField>
    );
}
